import { render, staticRenderFns } from "./tree-list.vue?vue&type=template&id=6c38835f&scoped=true"
import script from "./tree-list.vue?vue&type=script&lang=js"
export * from "./tree-list.vue?vue&type=script&lang=js"
import style0 from "./tree-list.vue?vue&type=style&index=0&id=6c38835f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c38835f",
  null
  
)

export default component.exports